import { useStore } from "@stores";
import { useEffect } from "react";

export const useFavorites = () => {
  const { favoriteStore, authStore } = useStore();

  useEffect(() => {
    if (authStore.currentUserId) {
      favoriteStore.getAll();
    }
  }, [favoriteStore, authStore.currentUserId]);

  return {
    favorites: favoriteStore.favorites,
    loading: favoriteStore.loading,
    toggle: favoriteStore.toggle,
  };
};
